import UploadImage from './src/main';

/* istanbul ignore next */
UploadImage.install = function(Vue) {
  Vue.component(UploadImage.name, UploadImage);
};

export default UploadImage;
